import { toDateTime } from "Helpers/Format";

import Button from "Components/Admin/Buttons";

// Rótulos do status do envio. 'pending'/'sending' existem porque uma falha de
// SMTP não derruba mais a operação: a mensagem entra na fila de reenvio
// (logs_email + EmailRetryJob) em vez de virar erro na hora.
const STATUS_LABELS = {
  success: "Enviado",
  pending: "Aguardando reenvio",
  sending: "Reenviando",
  error: "Falhou",
};

// "Aguardando reenvio (2/6) — 05/08/2026 14:32": o admin precisa saber que a
// mensagem ainda vai sair sozinha, e quando.
const statusLabel = (row, maxAttempts) => {
  const label = STATUS_LABELS[row.status] ?? row.status;

  if (row.status !== "pending" && row.status !== "sending") return label;

  const attempts = maxAttempts
    ? ` (${row.attempts ?? 0}/${maxAttempts})`
    : ` (${row.attempts ?? 0})`;

  const next = row.next_attempt_at
    ? ` — ${toDateTime(row.next_attempt_at)}`
    : "";

  return `${label}${attempts}${next}`;
};

// Factory porque a última coluna precisa do callback da linha (ver corpo).
export const buildColumns = ({ onViewBody, maxAttempts }) => [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Destinatário",
    accessor: "recipient",
  },
  {
    Header: "Assunto",
    accessor: (row) => row.subject ?? "—",
  },
  {
    Header: "Template",
    accessor: (row) => row.template ?? "—",
  },
  {
    Header: "Status",
    accessor: (row) => statusLabel(row, maxAttempts),
  },
  {
    Header: "Informações adicionais",
    accessor: (row) => row.extra_info ?? "—",
  },
  {
    Header: "Data",
    accessor: (row) => toDateTime(row.created_at),
  },
  {
    // O corpo NÃO vem na listagem (são vários KB de HTML por linha): é buscado
    // por id ao clicar. `has_body` diz se há algo a exibir.
    Header: "Corpo",
    accessor: "has_body",
    Cell: ({ cell }) => (
      <Button
        text="Ver corpo"
        type="button"
        variant="light"
        onClick={() => onViewBody(cell.row.original)}
      />
    ),
  },
];
